export const numberToTribeName = (input: string | number): string => {
  if (typeof input === "number") {
    input = `Tribe ${input}`;
  }

  // Return original name if it doesn't match our "Tribe X" pattern
  const match = String(input).match(/Tribe (\d+)/);
  if (!match) return String(input);

  const index = Number(match[1]) - 1;
  if (isNaN(index) || index < 0) return String(input);

  let name = "";
  let tempIndex = index;

  while (tempIndex >= 0) {
    name = String.fromCharCode(65 + (tempIndex % 26)) + name;
    tempIndex = Math.floor(tempIndex / 26) - 1;
  }

  return `Tribe ${name}`;
};

// Usage examples:
// numberToTribeName("Tribe 1") => "Tribe A"
// numberToTribeName("Tribe 2") => "Tribe B"
// numberToTribeName("Tribe 26") => "Tribe Z"
// numberToTribeName("Tribe 27") => "Tribe AA"
